import api from "../global/Api";
import { ENDPOINTS } from "../global/ApiEndpoints";

export const getAllWeldHours = async (page, size, searchString) => {
    const response = await api.get(`/${ENDPOINTS.WELD_HOURS_TABLE}`, {
        params: { page, size, search: searchString },
    });
    return response.data;
};

export const updateWeldHours = async (id, body) => {
    const response = await api.put(`/${ENDPOINTS.WELD_HOURS_TABLE}/${id}`, body);
    return response.data;
};

export const getWeldHoursSourceFile = async () => {
    const response = await api.get(`/${ENDPOINTS.WELD_HOURS_TABLE}/source`, {
        responseType: "blob",
    });
    return response.data;
};